/**
 * Typed rate-limit error shared by client and server code.
 *
 * Kept in a framework-free module (no `'use client'`, no React) so
 * server-only fetchers — pricing, Twitter, mentions, portfolio JSON —
 * can import it without dragging the rate-limit provider module into
 * the server bundle graph. The existing client re-export from
 * `providers/rate-limit-provider.tsx` still points here, so all
 * in-tree imports continue to work unchanged.
 *
 * See `providers/query-retry-policy.ts` for the classifier
 * (`isUpstreamRateLimit` / `isAnyRateLimit`) that consumes this.
 */

export class RateLimitError extends Error {
  readonly status = 429 as const;
  constructor(message = 'Too many requests') {
    super(message);
    this.name = 'RateLimitError';
  }
}

/**
 * Shorthand for the `if (res.status === 429) throw new RateLimitError();`
 * pattern that appears in most fetchers. Doesn't touch any other status
 * code — callers still handle 4xx/5xx themselves.
 */
export function throwIfRateLimited(res: Response, message?: string): void {
  if (res.status === 429) {
    throw new RateLimitError(message);
  }
}
